import { openDB, IDBPDatabase } from 'idb';
import { PersistedEvent } from './types';

const DB_NAME = 'event-collector';
const STORE_NAME = 'pending_events';
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDb(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: 'id' });
        }
      },
    });
  }
  return dbPromise;
}

export async function storePut(event: PersistedEvent): Promise<void> {
  const db = await getDb();
  await db.put(STORE_NAME, event);
}

export async function storeGetAll(): Promise<PersistedEvent[]> {
  const db = await getDb();
  return db.getAll(STORE_NAME);
}

export async function storeMarkAcked(ids: string[]): Promise<void> {
  if (ids.length === 0) return;
  const db = await getDb();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  await Promise.all(ids.map((id) => tx.store.delete(id)));
  await tx.done;
}

export async function storeDeleteOldest(count: number): Promise<void> {
  if (count <= 0) return;
  const db = await getDb();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const keys = await tx.store.getAllKeys();
  const toDelete = (keys as string[]).slice(0, count);
  await Promise.all(toDelete.map((key) => tx.store.delete(key)));
  await tx.done;
}

export function resetStoreForTesting(): void {
  dbPromise = null;
}
